import styled from 'styled-components'

export const DayViewWrapper = styled.div`
  height: calc(100vh - 135px);
  overflow: auto;
  align-items: flex-start;
  border: 1px solid #e6e8eb;
  border-left: none;
  border-right: none;
`
